<div class="border-top border-bottom col-12 my-5 py-4">
  <button class="btn btn-link txt-darkGray title_3 my-2 border-0" type="button" (click)="openReportModale(reportModale)">
    {{ 'COMMON.REPORT.ACCOMMODATION.BUTTON' | translate }}
  </button>
</div>

<ng-template #reportModale let-modal>
  <div class="modal-container overflow-auto hidden-scrollbar p-4">

    <div class="d-flex justify-content-between pb-4 border-bottom mb-4">
      <h2 class="title_1 d-flex gap-16">
        {{ 'COMMON.REPORT.ACCOMMODATION.TITLE' | translate }}
      </h2>
      <button (click)="modal.close()" aria-label="Close" class="lightGray2 btn border-0 m-0 p-0" type="button">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>

    <ng-container *ngIf="!isLogged; else loggedBlock">
      <app-form-login></app-form-login>
    </ng-container>

    <ng-template #loggedBlock>
      <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="page === 0">
        <label class="title_2 pb-3" for="reportField">{{ 'COMMON.REPORT.ACCOMMODATION.QUESTION' | translate }}</label>
        <mat-form-field class="w-100 no_underline br" [appearance]="'fill'" floatLabel="always">
          <textarea spellcheck="true" [formControl]="form.controls.report" rows="5" cols="33" id="reportField"
            matInput minlength="20" #message
            [placeholder]="'COMMON.REPORT.ACCOMMODATION.PLACEHOLDER' | translate" required></textarea>
          <span class="mb-2 text-danger minitext_2" *ngIf="formError && formError.length > 0">
            {{ formError | translate }}
          </span>
          <mat-hint align="start"><strong>
            {{ 'COMMON.REPORT.MINIMUM_WORDING' | translate }}
          </strong></mat-hint>
          <mat-hint align="end">{{message.value.length}} / 20</mat-hint>

        </mat-form-field>

        <div class="d-flex justify-content-end mt-3 align-items-center">
          <button class="btn btn-gradient-blue" type="submit">
            {{ 'COMMON.REPORT.BUTTON' | translate }}
          </button>
        </div>

      </form>

      <div *ngIf="page !== 0" [innerHTML]=" 'COMMON.REPORT.REPORT_SEND' |translate">

      </div>

    </ng-template>

  </div>
</ng-template>
